import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'

import styles from './styles.module.scss'

type IClickToTextActionsProps = {
  handleSave: () => void
  isSaving: boolean
  isEditMode: boolean
}

export const ClickToTextActions = observer(
  ({ handleSave, isSaving, isEditMode }: IClickToTextActionsProps) => {
    const onCancel = () => {
      uiStore.changeRoute({
        path: 'click-to-text',
      })
    }

    return (
      <div className={styles.actionsWrap}>
        <Button
          text={isEditMode ? 'Save' : 'Generate'}
          disabled={isSaving}
          loading={isSaving}
          onClick={handleSave}
        />
        <Button text={'Cancel'} disabled={isSaving} contained={'secondary'} onClick={onCancel} />
      </div>
    )
  }
)
